import React from 'react'
import { createUseStyles } from 'react-jss'

import StoreButtons from 'components/StoreButtons'
import COLORS from 'styles/colors'

const Success = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <p className={classes.title}>Seu anúncio foi atualizado!</p>
      <p className={classes.description}>
        Os dados do anúncio já estão atualizados! Agora é só baixar o aplicativo no link abaixo e
        fechar negócio hoje mesmo!
      </p>
      <StoreButtons titleColor={COLORS.greyscale.dark} />
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    padding: 24,
  },
  title: {
    fontSize: 21,
    color: COLORS.brand.primary,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 16,
  },
  description: {
    color: COLORS.greyscale.black,
    textAlign: 'center',
  },
})

export default Success
